import React from 'react';
import { Link } from 'react-router-dom';
import { useBrowsingWorkspaceRoutes } from 'v5/core/app-scope/useBrowsingWorkspaceRoutes';
import { myServices } from 'v5/services/services.connected.app';

/** A link to a contact's page in the workspace the user browses. */
export function ContactPageLink({ contactId, ...linkProps }) {
  const routes = useBrowsingWorkspaceRoutes(myServices);
  return <Link to={routes.contacts.detail(contactId)} {...linkProps} />;
}
